import { render, staticRenderFns } from "./NewReacomodo.vue?vue&type=template&id=2a5544f6"
import script from "./NewReacomodo.vue?vue&type=script&lang=js"
export * from "./NewReacomodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports